// $('#dimensions-link').on('click', (event) =>{
//      event.preventDefault();

   
//     const dimensionsTab = $('a.tab-title[href="#tab-shipping-amp-return"]');
//    if (dimensionsTab.length) {
//      console.log("huan",dimensionsTab)
//      dimensionsTab.trigger('click');
//       $('html, body').animate({
//             scrollTop: dimensionsTab.offset().top
//         }, 500);
//     }
// })
document.addEventListener('DOMContentLoaded', function () {

  const banner = document.querySelector(
    'li.product.banner[data-product-banner="1"]'
  );

  if (!banner) return;

  banner.style.cursor = 'pointer';

  banner.addEventListener('click', function (e) {

    e.preventDefault();

    if (typeof Fixtuur !== 'function') {
      console.log('Fixtuur is not loaded');
      return;
    }

    Fixtuur('#fixtuur-configure', {
      method: 'startConfiguration',
      data: {
        configuratorId: 'utopia-sofa'
      }
    });

  });

});